module.exports = __webpack_public_path__ + "assets/img/font6.4fb45590.png";